import { ReactElement } from 'react'
import BaseLayout from 'src/v3/components/base-layout'
import { SearchIcon } from '../core/icons'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => (
  <BaseLayout
    children={children}
    domain="events"
    subMenuItems={
      [
        // {
        //   name: 'Sentiment Analysis',
        //   route: '/',
        //   allowInLimited: true,
        //   icon: <SearchIcon />,
        // },
      ]
    }
  />
)
